import { registerComponent, scrollLock } from "helpers";

registerComponent(
  "wyatt-product-media-modal",
  class WyattProductMediaModal extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector("[data-product-media-modal]");

      if (!this.dialog) return;

      this.gallery = this.dialog.querySelector("[data-modal-gallery]");
      this.slides = this.gallery ? Array.from(this.gallery.children) : [];
      this.currentIndex = 0;

      document.body.append(this.dialog);

      this.bindEvents();
    }

    disconnectedCallback() {
      this.dialog?.remove();
    }

    bindEvents() {
      this.querySelectorAll("[data-open-modal]").forEach((button) => {
        button.addEventListener("click", () => {
          this.openAt(parseInt(button.dataset.openModal, 10));
        });
      });

      this.dialog.querySelectorAll("[data-close]").forEach((button) => {
        button.addEventListener("click", () => this.close());
      });

      this.dialog.addEventListener("click", (e) => {
        if (e.target === this.dialog) this.close();
      });

      this.dialog.addEventListener("close", () => scrollLock.disable());
    }

    openAt(index) {
      this.dialog.showModal();
      scrollLock.enable();
      this.goTo(index, "instant");
    }

    close() {
      this.dialog.close();
    }

    goTo(index, behavior = "smooth") {
      this.currentIndex = Math.max(0, Math.min(index, this.slides.length - 1));

      const slide = this.slides[this.currentIndex];
      if (slide && this.gallery) {
        const slideRect = slide.getBoundingClientRect();
        const galleryRect = this.gallery.getBoundingClientRect();
        this.gallery.scrollTo({
          top: this.gallery.scrollTop + slideRect.top - galleryRect.top,
          behavior,
        });
      }
    }
  },
);
